import { resourceReducer, getResources } from 'redux-resource';
import metaReducer from './metaReducer';

const deviceContracts = resourceReducer('deviceContracts', {
  plugins: [metaReducer],
});

export default deviceContracts;

export const getUserDeviceContracts = (state) =>
  getResources(state, 'userDeviceContracts');
export const getDeviceContract = (state, deviceContractId) =>
  getResources(state, [deviceContractId])[0];
